import { formatWholeMoney } from '@shared/utils/currency';
import type { SeatedOccupant } from '../../../floorPlans/apiHelpers';
import type { ServiceOccupant } from '../apiHelpers';

export interface TableSpend {
  /** Integer minor units (cents, pence). */
  amount: number;
  /** ISO 4217 code. */
  currency: string;
}

/**
 * What a seated table has spent, from the occupant's Lightspeed order in the service
 * occupants list (the floor plan only carries the occupant's id): every non-cancelled
 * check, before tax, the same total as the reservation card and Order Details, in the
 * order's currency. Null when there is no order yet.
 */
export const getTableSpend = (
  occupants: ServiceOccupant[],
  seatedOccupant: SeatedOccupant,
): TableSpend | null => {
  const occupant = occupants.find(
    ({ id, type }) => id === seatedOccupant.id && type === seatedOccupant.type,
  );
  const order = occupant?.lightspeedOrder;
  return order && order.status !== 'cancelled'
    ? { amount: order.subtotal, currency: order.currency }
    : null;
};

/** Whole units, so the label fits on a table: 10131 USD → "$101", GBP → "£101". */
export const formatTableSpend = ({ amount, currency }: TableSpend): string =>
  formatWholeMoney(amount, currency);
